import { Icon } from '@natera/material/lib/icon'
import { Popover } from 'radix-ui'
import { useState } from 'react'
import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui'
import type { AuditTrailStep } from '../model'

export function StepFilter({
  selectedStep,
  onSelectStep,
  steps,
}: {
  selectedStep: AuditTrailStep | null
  onSelectStep: (step: AuditTrailStep | null) => void
  steps: ReadonlyArray<{ label: string; value: AuditTrailStep }>
}) {
  const [isOpen, setIsOpen] = useState(false)

  const handleSelectStep = (step: AuditTrailStep) => {
    onSelectStep(step)
    setIsOpen(false)
  }

  return (
    <Popover.Root
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Popover.Trigger className="bg-surface-lowest data-[state=open]:bg-action-hovered hover:bg-action-hovered flex h-12 w-[90px] cursor-pointer items-center justify-between gap-2 rounded-sm border-none px-3 transition-colors">
        <Text
          className="text-text-primary"
          appearance="BODY2"
        >
          Step
        </Text>
        <Icon
          children="arrow_drop_down"
          className="text-content-high-emphasis"
        />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          align="start"
          asChild
        >
          <ul className="bg-surface-lowest z-50 m-0 min-w-[180px] list-none rounded-sm px-0 py-2 shadow-[0px_0.25px_3px_0px_rgba(0,0,0,0.04),0px_2.75px_9px_0px_rgba(0,0,0,0.19)]">
            {steps.map((step) => (
              <li key={step.value}>
                <button
                  className={cn(
                    'flex h-9 w-full cursor-pointer items-center gap-3 border-none bg-transparent px-3 py-1.5 text-left transition-colors',
                    {
                      'bg-primary-selected': selectedStep === step.value,
                      'active:bg-content-low-emphasis hover:bg-surface-low':
                        selectedStep !== step.value,
                    },
                  )}
                  onClick={() => handleSelectStep(step.value)}
                >
                  {selectedStep === step.value && (
                    <Icon
                      children="check"
                      className="text-content-high-emphasis"
                    />
                  )}
                  <Text
                    className="text-text-primary"
                    appearance="BODY2"
                  >
                    {step.label}
                  </Text>
                </button>
              </li>
            ))}
          </ul>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  )
}
